import React from 'react';
import { SimpleShowLayout } from 'react-admin';

export default ({ children, resources, parentResource, ...props }) => (
  <SimpleShowLayout
    {...props}
  >
    {React.Children.toArray(children).map(child => React.cloneElement(child, {
      parentResource,
      resources,
    }))}
  </SimpleShowLayout>
)

